// Public support/legal destinations must be supplied by the LAVYN owner.
// Never substitute invented addresses, policies, or a fake "message sent" state.
export const appInfo: {
  version: string;
  supportEmail: string | null;
  termsUrl: string | null;
  privacyUrl: string | null;
} = {
  version: '2.1.0',
  supportEmail: 'support@lavyntutor.com',
  termsUrl: '/terms',
  privacyUrl: '/privacy',
};
